import { render, staticRenderFns } from "./navigation-drawer.vue?vue&type=template&id=38ec792a&scoped=true"
import script from "./navigation-drawer.vue?vue&type=script&lang=js"
export * from "./navigation-drawer.vue?vue&type=script&lang=js"
import style0 from "./navigation-drawer.vue?vue&type=style&index=0&id=38ec792a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec792a",
  null
  
)

export default component.exports